import styled from "@emotion/styled";
import { Divider } from "@mui/material";

export const ReplacementReviewPageContent = styled.div({
	padding: "16px 20px"
});

export const ReplacementReviewDetailsWrapper = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	backgroundColor: theme.project.colors.backgroundColors.main,
	position: "relative"
}));

export const ReplacementReviewDetailsDivider = styled(Divider)({
	boxSizing: "border-box",
	width: "calc(100% - 32px)",
	marginLeft: "16px"
});
